export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_NOT_FOUND = 404;
export const HTTP_NOT_ACCEPTABLE = 406;
export const HTTP_INTERNAL_ERROR = 500;


/** User roles **/
export const ROLE_ADMIN = 'admin';
export const ROLE_CONSULTANT = 'consultant';
